import { legacyPlugins } from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/@unhead+vue@3.4.2_@oxc-project+types@0.153.0_esbuild@0.27.2_lightningcss@1.33.0_oxc-par_682ff309e66bdf5a9cb00a302f186b0e/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}